export default "__VITE_ASSET__BiZ0iSsY__"